function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledCompetitorsComparisonTableComponent } from "./competitors-comparison-table-component.scss";
import Picture from "/components/core/picture/picture-component";
import ComparisonFeatureComponent from "./comparison-feature/comparison-feature-component";
class CompetitorsComparisonTableComponent extends PureComponent {
    render() {
        const { title, subtitle, features, mondayLogo, competitorLogo } = this.props;
        return /*#__PURE__*/ _jsxs(StyledCompetitorsComparisonTableComponent, {
            className: "competitors-comparison-table",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "competitors-comparison-titles-wrapper",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "competitors-comparison-title",
                            children: title
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "competitors-comparison-subtitle",
                            children: subtitle
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "table-wrapper",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "table-row table-header",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "table-cell"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "table-cell",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "monday-logo-wrapper",
                                        style: {
                                            height: `${mondayLogo.height}%`
                                        },
                                        children: /*#__PURE__*/ _jsx(Picture, {
                                            className: "monday-logo",
                                            src: "/static/img/monday-logos/monday_logo_short.png"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "table-cell vs-cell",
                                    children: "vs."
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "table-cell",
                                    children: competitorLogo && /*#__PURE__*/ _jsx("div", {
                                        className: "competitor-logo-wrapper",
                                        style: {
                                            height: `${competitorLogo.height}%`
                                        },
                                        children: /*#__PURE__*/ _jsx(Picture, {
                                            className: "competitor-logo",
                                            src: competitorLogo.src
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "table-cell"
                                })
                            ]
                        }),
                        features.map((feature, i)=>{
                            return /*#__PURE__*/ _jsx(ComparisonFeatureComponent, _object_spread_props(_object_spread({}, feature.props), {
                                index: i
                            }), i);
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "mobile-table-wrapper",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "table-header",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "table-cell",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "monday-logo-wrapper",
                                        style: {
                                            height: `${mondayLogo.height}%`
                                        },
                                        children: /*#__PURE__*/ _jsx(Picture, {
                                            className: "monday-logo",
                                            src: "/static/img/monday-logos/monday_logo_short.png"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "table-cell",
                                    children: competitorLogo && /*#__PURE__*/ _jsx("div", {
                                        className: "competitor-logo-wrapper",
                                        style: {
                                            height: `${competitorLogo.height}%`
                                        },
                                        children: /*#__PURE__*/ _jsx(Picture, {
                                            className: "competitor-logo",
                                            src: competitorLogo.src
                                        })
                                    })
                                })
                            ]
                        }),
                        features.map((feature, i)=>{
                            return /*#__PURE__*/ _jsx(ComparisonFeatureComponent, _object_spread_props(_object_spread({}, feature.props), {
                                index: i
                            }), i);
                        })
                    ]
                })
            ]
        });
    }
}
export { CompetitorsComparisonTableComponent as default };
CompetitorsComparisonTableComponent.defaultProps = {
    features: [],
    mondayLogo: {}
};
